import { Component, Inject, PLATFORM_ID, AfterViewInit, AfterViewChecked } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { WebServiceService } from './services/web-service.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit, AfterViewChecked {
  constructor(private webservice: WebServiceService, @Inject(PLATFORM_ID) private platformId: Object) { }

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const adjustToken = 'o3egz4z0720w';
    if (adjustToken) {
      const adjustSmartBanner = (window as any).AdjustSmartBanner;
      if (adjustSmartBanner?.init) {
        try {
          adjustSmartBanner.init({
            appToken: adjustToken
          });
          console.log('🎉 Adjust Smart Banner initialized successfully from window');
          return;
        } catch (error) {
          console.error('❌ Adjust Smart Banner initialization failed:', error);
          return;
        }
      }

      try {
        import('@adjustcom/smart-banner-sdk').then(({ default: AdjustSmartBanner }) => {
          AdjustSmartBanner.init({
            appToken: adjustToken
          });
        }).catch((error) => {
          console.error('❌ Adjust Smart Banner SDK dynamic import failed:', error);
        });
      } catch (error) {
        console.error('❌ Adjust Smart Banner initialization failed:', error);
      }
    } else {
      console.warn('⚠️ Adjust Smart Banner token not found');
    }
  }

  ngAfterViewChecked(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    
    var navigate = document.querySelectorAll('.open-popup:not([data-listener-added])');

    for (var i = 0; i < navigate.length; i++) {
      const element = navigate[i] as HTMLElement;
      element.setAttribute('data-listener-added', 'true');
      element.addEventListener('click', (event: any) => {
        if (event.target.href?.includes('/mobil-indir')) {
          this.navigateTo(event, event.target.href);
        }
      });
    }
  }

  navigateTo($event: any, url: string) {

    if (url?.includes('/mobil-indir')) {
      url = '#mobil-uygulama-indir'
    }

    $event.preventDefault();
    this.webservice.goDetail(url);
    return false;
  }

}
